// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_en-a";
export var fulfillmentFormRail = "_en-9";
export var headerTitleRow = "_en-c";
export var orderDetailsWrapper = "_en-7";
export var orderLinkTrigger = "_en-2";
export var paymentInformationGrid = "_en-h";
export var paymentSummaryColumn = "_en-i";
export var shipmentContainer = "_en-b";
export var shipmentDetailsMainPane = "_en-8";
export var shipmentNavigationCard = "_en-5";
export var shipmentNavigationRail = "_en-3";
export var shipmentNavigationRailHeader = "_en-4";
export var shipmentSummaryFact = "_en-e";
export var shipmentSummaryGrid = "_en-d";
export var shipmentSummaryMetadataRow = "_en-f";
export var shipmentSummaryTags = "_en-g";
export var shipmentWorkspace = "_en-0";
export var shipmentWorkspaceContent = "_en-6";
export var shipmentWorkspaceHeader = "_en-1";